
//import { NgxSpinnerService } from "ngx-spinner";
import { Injectable } from "@angular/core";
import {
  Router,
} from '@angular/router';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { catchError, finalize, filter, switchMap, take } from "rxjs/operators";
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from '@doc/api/server-bo';
import { TranslateService } from "@ngx-translate/core";
import { AuthenticationService } from "@doc/api/server-bo";

@Injectable()
export class CommonInterceptor implements HttpInterceptor {

  // Configure URL patterns that should skip the loader
  // Add API endpoints here that don't need to show the spinner
  private readonly skipLoaderUrls: string[] = [
    '/assets/i18n/',
    '/api/files/download',           // Example: file download endpoints
    '/api/notifications/poll',       // Example: polling endpoints
    '/api/health',                   // Example: health check endpoints
    '/api/ResumableUpload/',         // All resumable upload calls (initialize, chunk, verify, complete, incomplete, session)
    '/api/File/uploadFile',          // Upload API should run without global loader
    '/api/File/updatefile',          // Update/upload metadata silently
    '/api/File/GetFileFromCloud/',   // Range/chunked downloads use own progress UI
    '/api/File/preview',             // Tokenised preview/download proxy
    '/api/Folder/manifest/',         // Folder download tree listing
    '/api/Folder/prepare-download/', // Background zip prepare
    '/api/Folder/download-status/',  // Zip prepare poll
    '/api/Folder/download-prepared/', // Prepared zip Range download
    '/api/Folder/download/',         // Legacy sync zip (fallback)
    '/api/Folder/create',            // Folder creation during upload should be silent
    '/api/Share/file',               // Share calls from upload should be silent
    '/api/Share/folder',             // Share calls from upload should be silent
    '/api/File/check-duplicate-names', // Duplicate check can hang via proxy; keep UI interactive
    '/api/Dashboard/', // Dashboard stats/tables refresh without blocking the filter drawer
    '/api/User/getUsersWithoutInvitations', // Dashboard filter user dropdown
    '/api/User/getUsersByDepartments', // Dashboard filter user dropdown
    '/api/User/getAllUserList', // Share popup user picker
    '/api/UserActivity/getAllActions', // Dashboard filter action types
    '/api/Department/getList', // Dashboard filter departments
    '/api/Category/getList', // Dashboard filter SBU/categories
    '/api/LookupType/getList',
    '/api/LookupItem/getList',
    '/api/LookupItem/getByLookupTypeId',
    '/api/User/getList',
    '/api/DocumentCategory/getList',
    // AI status polls / chat — also send X-Skip-Loader from AiServiceService
    'ai/jobs-for',
    'ai/processing-status',
    'documentprocessing/ai/status',
    'documentai/chat',
    'documentai/query',
    'ai/chat',
    'ai/query',
  ];
  private readonly AUTH_BYPASS_URLS: string[] = [
    '/api/Auth/login',
    '/api/Auth/loginsso',
    '/api/Auth/refresh',
    '/api/Auth/ForgotPassword',
    '/api/auth/ResetPassword',
    '/api/UserInvitation/Register'
  ];
  private readonly REFRESH_ALLOWED_URLS: string[] = [
    '/api/ResumableUpload/'
  ];
  private isLoggingOut = false;
  private isRefreshing = false;
  private refreshTokenSubject = new BehaviorSubject<string | null>(null);
  constructor(private router: Router, private spinner: NgxSpinnerService, private messageService: MessageService,
    private translateService: TranslateService, private authService: AuthenticationService) { }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ) {
    if (request.url.includes('/assets/i18n/')) {
      return next.handle(request);
    }

    const shouldBypassAuth = this.AUTH_BYPASS_URLS.some(url =>
      request.url.includes(url)
    );
    // Check if loader should be skipped
    const shouldSkipLoader = this.shouldSkipLoader(request);
    
    if (!shouldSkipLoader) {
      this.spinner.show();
    }

    let headers = request.headers;
    if (!shouldBypassAuth) {
      const token = localStorage.getItem('accessToken');
      if (token) {
        headers = headers.set('Authorization', `Bearer ${token}`);
      }
    }

    // FormData + XMLHttpRequest: if Content-Type is set without boundary=..., the browser
    // cannot build multipart correctly — DevTools may show "Form Data (0)" and the API gets an empty/wrong body.
    if (request.body instanceof FormData) {
      const ct = headers.get('content-type');
      if (ct != null && !/boundary=/i.test(ct)) {
        headers = headers.delete('content-type');
      }
    } else {
      const contentType = request.headers.get('content-type');
      if (contentType && contentType !== 'multipart/form-data') {
        headers = headers.set('content-type', contentType);
      }
      if (contentType === 'multipart/form-data') {
        headers = headers.delete('content-type');
      }
    }
    // let headers = new HttpHeaders()
    //   .set("content-type", contentType)
      // .set("Access-Control-Allow-Origin", "*")
      // .set("Authorization", `Bearer ${token}`);
    
    // Remove the X-Skip-Loader header if it exists (it's only for internal use)
    if (request.headers.has('X-Skip-Loader')) {
      headers = headers.delete('X-Skip-Loader');
    }
    const clonedRequest = request.clone({ headers });
    return next.handle(clonedRequest).pipe(
      catchError((err) => this.handleAuthError(err, clonedRequest, next)),
      finalize(() => {
        setTimeout(() => {
          if (!shouldSkipLoader) {
            this.spinner.hide();
          }
        }, 300);
      })
    );

    // if (token) {
    //   headers = headers.set('Authorization', `Bearer ${token}`);
    // }
    
    //below if-else implemented for customer portal login token

    // if(request.url.includes("/api/Token/getAccessToken") || request.url.includes("/api/Token/sendLoginOtp"))
    // {
    //   const idToken = JSON.parse(this.coreService.decryptValue(localStorage.getItem('idToken')));
    //   headers = headers.set("Authorization", `Bearer ${idToken}`)
    // }
    // else{
    //   headers = headers.set("Authorization", `Bearer ${token}`)
    // }

    // for image request in applicant service
    // if (accept) {
    //   headers = headers.set('accept', accept)
    // }

    // let cloneRequest = request.clone({
    //   headers,
    // });

    // if (contentType === "multipart/form-data") {
    //   cloneRequest = cloneRequest.clone({
    //     headers: cloneRequest.headers.delete("content-type"),
    //   });
    // }

    // return next.handle(cloneRequest).pipe(
    //   catchError((x) => this.handleAuthError(x)),
    //   finalize(() =>
    //     setTimeout(() => {
    //       if (!shouldSkipLoader) {
    //         this.spinner.hide();
    //       }
    //     }, 500)
    //   )
    // );
  }

  /**
   * Determines if the loader should be skipped for this request
   * @param request - The HTTP request
   * @returns true if loader should be skipped, false otherwise
   */
  private shouldSkipLoader(request: HttpRequest<unknown>): boolean {
    // Method 1: Check for explicit X-Skip-Loader header (case-insensitive)
    const skipLoaderHeader =
      request.headers.get('X-Skip-Loader') ?? request.headers.get('x-skip-loader');
    if (skipLoaderHeader === 'true') {
      return true;
    }

    // Method 2: Check if URL matches any configured skip patterns
    const url = request.url.toLowerCase();
    return this.skipLoaderUrls.some(pattern => url.includes(pattern.toLowerCase()));
  }

  // private handleAuthError(err: HttpErrorResponse): Observable<any> {
  //   console.log("error.err", err);
  //   console.log(this.router.url);
  //   console.log(typeof (this.router.url))
  //   const currentUrl = this.router.url;

  //   if (err.status === 401 && !currentUrl.includes('/auth/login')) {

  //     const errorObj = {
  //       isUnAuthorized: true,
  //     };
  //     const translations = this.translateService.instant(['General.InvalidSession']);
  //     this.messageService.add({
  //       severity: 'error',
  //       summary: 'Error',
  //       detail: err?.error?.errorMessage || translations['General.InvalidSession']
  //     });
  //     localStorage.removeItem('accessToken');
  //     this.router.navigate(['auth/login']);
  //   }

  //   return throwError(err);
  // }
  private handleAuthError(err: HttpErrorResponse, request: HttpRequest<unknown>, next: HttpHandler): Observable<any> {
  // const currentUrl = this.router.url;

  // if (
  //   (err.status === 401 || err.status === 403) &&
  //   !currentUrl.includes('/auth/login') &&
  //   !this.isLoggingOut
  // ) 
  const isAuthApi =
      this.AUTH_BYPASS_URLS.some(url => err.url?.includes(url));

    const isRefreshAllowed = this.REFRESH_ALLOWED_URLS.some(url => request.url.includes(url));

    if ((err.status === 401) && !isAuthApi && isRefreshAllowed && !this.isLoggingOut) {
      const refreshToken = localStorage.getItem('refreshToken');
      if (!refreshToken) {
        this.performLogout(err);
        return throwError(() => err);
      }

      if (this.isRefreshing) {
        return this.refreshTokenSubject.pipe(
          filter((token) => token != null),
          take(1),
          switchMap((token) => next.handle(this.addAuthHeader(request, token!)))
        );
      }

      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.refreshToken(refreshToken).pipe(
        switchMap((response: any) => {
          const newAccessToken = response?.data?.token || response?.data?.Token;
          const newRefreshToken = response?.data?.refreshToken || response?.data?.RefreshToken || refreshToken;

          if (!newAccessToken) {
            throw new Error('Missing access token in refresh response.');
          }

          localStorage.setItem('accessToken', newAccessToken);
          if (newRefreshToken) {
            localStorage.setItem('refreshToken', newRefreshToken);
          }

          this.refreshTokenSubject.next(newAccessToken);
          return next.handle(this.addAuthHeader(request, newAccessToken));
        }),
        catchError((refreshErr) => {
          this.performLogout(refreshErr);
          return throwError(() => refreshErr);
        }),
        finalize(() => {
          this.isRefreshing = false;
        })
      );
    }

    const isPublicShareLinkApi = request.url.includes('/api/AnonymousShare');

    if ((err.status === 401) && !isAuthApi && !this.isLoggingOut && !isPublicShareLinkApi) {
      this.performLogout(err);
    }

    return throwError(() => err);
}

  private addAuthHeader(request: HttpRequest<unknown>, token: string): HttpRequest<unknown> {
    return request.clone({
      headers: request.headers.set('Authorization', `Bearer ${token}`),
    });
  }

  private performLogout(err: HttpErrorResponse) {
    if (this.isLoggingOut) {
      return;
    }

    this.isLoggingOut = true;
    const translations = this.translateService.instant([
      'General.InvalidSession'
    ]);

    this.messageService.clear();
    this.messageService.add({
      severity: 'error',
      summary: 'Session Expired',
      detail:
        err?.error?.errorMessage ||
        translations['General.InvalidSession'],
    });

    localStorage.clear();
    sessionStorage.clear();

    setTimeout(() => {
      this.router.navigate(['/auth/login']).then(() => {
        this.isLoggingOut = false;
      });
    }, 100);
  }

}
